import { render, staticRenderFns } from "./CategoryAdminView.vue?vue&type=template&id=34ae3068&scoped=true"
import script from "./CategoryAdminView.vue?vue&type=script&lang=js"
export * from "./CategoryAdminView.vue?vue&type=script&lang=js"
import style0 from "./CategoryAdminView.vue?vue&type=style&index=0&id=34ae3068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ae3068",
  null
  
)

export default component.exports